import { Button } from '@aws-amplify/ui-react';
import { TbTrash } from 'react-icons/tb';

interface RemoveButtonProps {
  /** What the button removes, shown on hover ("Remove user", "Delete API key"). */
  title: string;
  onClick: () => void;
  isDisabled?: boolean;
  /** Classes added to the button's own, e.g. `nohover` for one without a box or shadow. */
  className?: string;
  /** No tooltip, where the trash speaks for itself; the title stays the button's accessible name. */
  isTitleHidden?: boolean;
}

/** The app's row action that removes or deletes something: a small destructive trash button. */
export function RemoveButton({ title, onClick, isDisabled, className, isTitleHidden }: RemoveButtonProps) {
  return (
    <Button
      className={className ? `tiny ${className}` : 'tiny'}
      variation="destructive"
      title={isTitleHidden ? undefined : title}
      aria-label={title}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      <TbTrash />
    </Button>
  );
}
